/**
 * Created by luka on 23.02.2018.
 */
import {post} from "../utils/api";
import {DECLINE_SUCCESSFUL, RETRY_SUCCESSFUL} from "../utils/constants";
import {
    DECLINE_PAYOUT_LOADING, DECLINE_PAYOUT_SUCCESS, LOADING_DECLINE_PAYOUT_FAILED, LOADING_RETRY_FAILED, RETRY_LOADING,
    RETRY_SUCCESS,
} from "../actions/types";
import {daysFetchData} from "../overview/OverviewAction";
import {clearWorkout} from "../utils/workoutStore";

export function loadingRetryFailed(error) {
    return {
        type: LOADING_RETRY_FAILED,
        error
    };
}

export function retryLoading(bool) {
    return {
        type: RETRY_LOADING,
        isLoading: bool
    };
}

export function retrySuccess(response) {
    return {
        type: RETRY_SUCCESS,
        response
    };
}

export function fetchRetry() {
    return (dispatch) => {
        dispatch(retryLoading(true));

        post('retry', {})
            .then((response) => {
                if (response.msg === RETRY_SUCCESSFUL ) {
                    clearWorkout()
                    dispatch(daysFetchData());
                    dispatch(retrySuccess(response));
                }
                dispatch(retryLoading(false));
            })
            .catch((error) => {
                dispatch(loadingRetryFailed(error));
                dispatch(retryLoading(false));
            });
    };
}


// WEBPACK FOOTER //
// ./src/retry/RetryAction.js